
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Employee Sports Meet </h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm employee-sports section-banner-bg-1">
    <div class="container">
    	<div class="row justify-content-center align-items-center">
			<div class="sec-title text-center">
				<h2> Employee <span>Sports & Cultural Meet 20122</span></h2>
			</div>
                <div class="row g-3 row-cols-1 row-cols-lg-2 justify-content-between align-items-start">
		            <div class="col-lg-12">
		                <ul class="nav nav-pills  me-2" role="tablist" aria-orientation="vertical">
		                    <li class="nav-item">
		                        <a class="nav-link active" id="tabh-1-1" data-bs-toggle="pill" data-bs-target="#tab-1-1" type="button" role="tab" aria-controls="tab-1-1" aria-selected="true"> RULE BOOK 2022</a>
		                    </li>
		                    <li class="nav-item">
		                        <a class="nav-link" id="tabh-1-2" data-bs-toggle="pill" data-bs-target="#tab-1-2" type="button" role="tab" aria-controls="tab-1-2" aria-selected="false"> SCHEDULES 2022 </a>
		                    </li>
		                    <li class="nav-item">
		                        <a class="nav-link"  routerLink="/result">RESULT 2022</a>
		                    </li>

		                </ul>
		            </div>
		            <div class="col-lg-12">
		                <div class="tab-content">
		                    <div class="tab-pane fade show active" id="tab-1-1" role="tabpanel" aria-labelledby="tabh-1-1">
			                    <div class="widget_title inner-title">
			                        <h4>SPORTS MEET RULE BOOK 2022</h4>
			                    </div>
			                     <div class="text-center">
			                        <iframe src="https://drive.google.com/file/d/1KkKyZB7aB5kcTKMyT4I1kvLUsuXoGavm/preview?" height="600" width="800" class="iframe-sm"></iframe>
			                    </div>



		                    </div>
		                    <div class="tab-pane fade" id="tab-1-2" role="tabpanel" aria-labelledby="tabh-1-2">
			                    <div class="widget_title inner-title">
			                        <h4>SPORTS MEET SCHEDULES 2022</h4>
			                    </div>
			                     <div class="text-center">
			                        <iframe src="https://drive.google.com/file/d/1N7dXRjpMDXTA93YKGMbj4lZlHnrk4Hc2/preview" height="600" width="800" class="iframe-sm"></iframe>
			                    </div>

		                    </div>

		            </div>
		        </div>

		    </div>

         </div>
    </div>
</section>
